import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ExaminationSlideText, ExaminationSlideTextList } from '../model/examinationSlides.model';
import { AuthenticationService } from './authentification.service';

@Injectable()
export class ExaminationSlidesTextService extends KiwixiService {

    apiExaminationSlidesText = environment.server + 'examinations_slides_text/';

    getFaqs() {
        return [
            {
                questionType: "varListing",
                question: "Quelles sont les variables accessible pour le LILATE ?",
                answers: [
                    {
                        balise: "{{ lilate.start | date: 'dd MMM yyyy HH:mm' }}",
                        text: "Heure de début",
                        example: "21 Avril 2023 14:00"
                    },
                    {
                        balise: "{{ lilate.end | date: 'dd MMM yyyy HH:mm' }}",
                        text: "Heure de fin",
                        example: "21 Avril 2023 15:00"
                    },
                    {
                        balise: "{{ lilate.targeted_level }}",
                        text: "Level visé",
                        example: "B2"
                    },
                    {
                        balise: "{{ lilate.organization.name }}",
                        text: "Nom de l'OF",
                        example: "Lingueo"
                    }
                ]
            },
            {
                questionType: "varListing",
                question: "Quelles sont les variables accessible pour le candidat ?",
                answers: [
                    {
                        balise: "{{ lilate.student.user.first_name }}",
                        text: "Prénom du candidat",
                        example: "John"
                    },
                    {
                        balise: "{{ lilate.student.user.last_name }}",
                        text: "Nom du candidat",
                        example: "Doe"
                    },
                    {
                        balise: "{{ lilate.student.user.birthdate | date: 'dd MMM yyyy' }}",
                        text: "Date de naissance du candidat",
                        example: "21 Avril 1980"
                    },
                    {
                        balise: "{{ lilate.student.user.email }}",
                        text: "Email du candidat",
                        example: "john.doe@gmail.com"
                    }
                ]
            },
            {
                questionType: "varListing",
                question: "Quelles sont les variables accessible pour l'examinateur ?",
                answers: [
                    {
                        balise: "{{ lilate.teacher.user.first_name }}",
                        text: "Prénom de l'examinateur",
                        example: "John"
                    },
                    {
                        balise: "{{ lilate.teacher.user.last_name }}",
                        text: "Nom de l'examinateur",
                        example: "Doe"
                    },
                ]
            },
        ]
    }

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,
        private authentificationService: AuthenticationService
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getExaminationsSlidesText(params: HttpParams): Observable<ExaminationSlideTextList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationSlideTextList>(this.apiExaminationSlidesText + '?salt=' + Math.random(), {
            headers: header,
            params: params
        })
            .pipe(
                map(_Examinations => _Examinations),
                catchError(this.handleErrorObservable<ExaminationSlideTextList>(`getObservableExaminationsSLidesText`))
            );
    }

    getExaminationsSlideTextById(id: string): Observable<ExaminationSlideText> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationSlideText>(this.apiExaminationSlidesText + id + '/?salt=' + Math.random(), {
            headers: header,
        })
            .pipe(
                map(ExaminationSlideText => ExaminationSlideText),
                catchError(this.handleErrorObservable<ExaminationSlideText>(`getObservableExaminationsSLidesText`))
            );
    }

    getExaminationsSlideTextsByUrl(_url): Observable<ExaminationSlideTextList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationSlideTextList>(_url + '?salt=' + Math.random(), {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSlideTextList>(`getExamination`))
            );
    }

    postExaminationSlidesText(params): Observable<ExaminationSlideText> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<ExaminationSlideText>(this.apiExaminationSlidesText, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSlideText>(`Création d'une slide`)),
            );
    }

    patchExaminationSlidesText(id: string, params): Observable<ExaminationSlideText> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<ExaminationSlideText>(this.apiExaminationSlidesText + id + '/', params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSlideText>(`Edition d'une slide de text`)),
            );
    }
    deleteExaminationSlidesText(id): Observable<ExaminationSlideText> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.delete<ExaminationSlideText>(this.apiExaminationSlidesText + id + '/', {
            headers: header,
        })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSlideText>(`delete d'une slide de text`))
            );
    }
}
